import i18n from './index'

/**
 * Main translation function - wrapper around i18next t() function
 * @param {string} key - Translation key (e.g., 'common.buttons.save')
 * @param {object} options - Interpolation options (e.g., { count: 5, name: 'John' })
 * @returns {string} Translated string
 */
export const t = (key, options = {}) => {
  return i18n.t(key, options)
}

/**
 * Pluralization helper
 * i18next handles pluralization automatically when you pass a count
 * @param {string} key - Translation key
 * @param {number} count - Count for pluralization
 * @param {object} options - Additional interpolation options
 * @returns {string} Translated string with proper pluralization
 *
 * @example
 * // In translation file:
 * // "items": "{{count}} item",
 * // "items_plural": "{{count}} items"
 * plural('items', 5) // "5 items"
 * plural('items', 1) // "1 item"
 */
export const plural = (key, count, options = {}) => {
  return i18n.t(key, { ...options, count })
}

/**
 * Change the current language
 * @param {string} lng - Language code (e.g., 'en', 'es', 'fr')
 */
export const changeLanguage = async (lng) => {
  await i18n.changeLanguage(lng)
}

/**
 * Get current language code
 * @returns {string} Current language code
 */
export const getCurrentLanguage = () => {
  return i18n.language || i18n.options.fallbackLng
}
